import { CompanyLocation } from "../../utils/types";

export const findDifferentKeys = (obj1: any, obj2: any) => {
	if (!obj1 || !obj2) return [];
	const differentKeys = Object.keys(obj1).filter(
		(key) => obj1[key] !== obj2[key]
	);
	return differentKeys;
};
